import{directive as e}from"../directive.js";import{UnsafeHTMLDirective as le}from"./unsafe-html.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class pe extends le{}pe.directiveName="unsafeSVG",pe.resultType=2;const fe=e(pe);export{fe as unsafeSVG};
//# sourceMappingURL=unsafe-svg.js.map
